import React, { useState, useEffect, useContext } from 'react';
import ControlButtonAdd from './ControlButtonAdd';
import ControlButtonDelete from './ControlButtonDelete';
import ControlButtonUpdate from './ControlButtonUpdate';
import ControlButtonVisibility from './ControlButtonVisibility';
import Pager from './Pager';
import Loading from './Loading';
import SuccessAlert from './SuccessAlert';
import MyQuestionsContext from '../context/QuestionsContext';
import ModalQuestionsAdd from './ModalQuestionsAdd';
import ModalItemsDelete from './ModalItemsDelete';
import ModalQuestionsUpdate from './ModalQuestionsUpdate';

const ControlQuestions = () => {
    const{getQuestionsAdmin, questions, maxPage, setPageAdmin, pageAdmin, error, changeQuestionVisibility, loading, setQuestion, setError, deleteQuestion} = useContext(MyQuestionsContext);

    const[isModalItemsDeleteOpen, setIsModalItemsDeleteOpen] = useState(false);
    const[isModalQuestionsAddOpen, setIsModalQuestionsAddOpen] = useState(false);
    const[isModalQuestionsUpdateOpen, setIsModalQuestionsUpdateOpen] = useState(false);

    const[itemId, setItemId] = useState(null);
    const[successAlert, setSuccessAlert] = useState(null);

    const handleChangeQuestionVisibility = async (questionId) => {
        const res = await changeQuestionVisibility(questionId);
        if(res.error){
            setError({"error": true, "message": res.response})
            setTimeout(() => {
                setError({"error": false, "message": ""});
            }, 3000);
        }else{
            setError({"error": false, "message": ""})
            setSuccessAlert("Visibilidad cambiada correctamente")
            setTimeout(() => {
                setSuccessAlert(null)
            }, 2000);
        }
    }

    useEffect(() =>  {
        getQuestionsAdmin();
    }, [pageAdmin]);

    useEffect(() => {
        setPageAdmin(0);
    }, []);

    return (
        <>
            <ModalItemsDelete isModalItemsDeleteOpen={isModalItemsDeleteOpen} setIsModalItemsDeleteOpen={setIsModalItemsDeleteOpen} setSuccessAlert={setSuccessAlert} loading={loading} deleteFunction={deleteQuestion} itemId={itemId}/>
            <ModalQuestionsAdd isModalQuestionsAddOpen={isModalQuestionsAddOpen} setIsModalQuestionsAddOpen={setIsModalQuestionsAddOpen} setSuccessAlert={setSuccessAlert} />
            <ModalQuestionsUpdate isModalQuestionsUpdateOpen={isModalQuestionsUpdateOpen} setIsModalQuestionsUpdateOpen={setIsModalQuestionsUpdateOpen} setSuccessAlert={setSuccessAlert} />
            <SuccessAlert isVisible={successAlert} />
            <div className='flex flex-col'>
                <ControlButtonAdd onClick={()=>setIsModalQuestionsAddOpen(true)} />
                {error.error ? <h1 className='text-center text-red-500 w-full my-4'>{error.message}</h1> : null}
                {questions && questions.length > 0 && questions.map((question, index) => (
                        <div className='bg-itemControlBackground rounded-2xl w-full my-4 px-2 py-3 flex flex-col sm:flex-row ' key={index}>
                            <div className='flex flex-col w-full sm:w-[80%]'>
                                <div className='break-words' >
                                    {question.questionTitle}
                                </div>
                                <div className='break-words font-light'>
                                    {question.questionAnswer}
                                </div>
                            </div>
                            <div className='mx-auto flex flex-row w-[60%] sm:w-[20%] justify-around'>
                                <ControlButtonUpdate onClick={()=>{setQuestion(question); setIsModalQuestionsUpdateOpen(true)}} />
                                <ControlButtonVisibility visible={question.visible} onClick={()=>handleChangeQuestionVisibility(question.questionId)} />
                                <ControlButtonDelete onClick={()=>{setItemId(question.questionId); setIsModalItemsDeleteOpen(true)}} />
                            </div>
                        </div>
                ))}
                <div>
                    <Loading isLoading={loading} />
                    {questions && questions.length < 1 && <h1 className='text-center w-full font-light my-4'>No hay registros para mostrar</h1>}
                    <div className='flex justify-center mb-4'>
                        <Pager maxPage={maxPage} setPage={setPageAdmin} />
                    </div>
                </div>

            </div> 
        </>
    );
}
 
export default ControlQuestions;